import React from 'react';
import PropTypes from 'prop-types';

export const teamsListPropTypes = {
    teams: PropTypes.array,
    groupBy: PropTypes.string,
    listType: PropTypes.string,

    teamDisplayProps: PropTypes.shape({
        // TeamDisplay
        displayLogo: PropTypes.bool,
        displayName: PropTypes.bool,
        displayTricode: PropTypes.bool,

        // TeamDisplayLink
        link: PropTypes.string,
        anchorLinks: PropTypes.bool,
        pageName: PropTypes.string,

        // TeamDisplayCheckbox
        selectedTeams: PropTypes.array,
        changeTeamSelection: PropTypes.func,
        changeDivisionSelection: PropTypes.func,
        changeConferenceSelection: PropTypes.func,
        changeAllSelection: PropTypes.func,
    }),

    // UI Props
    layoutClasses: PropTypes.string,
    onScroll: PropTypes.func
};